import { Row } from "antd";
import styled from "styled-components";

export const LoginStyled = styled(Row)`
  > div {
    justify-content: center;
  }

  .a-section {
    display: flex;
  }

  .left-section {
    width: 56%;
  }

  .right-section {
    width: 44%;

    img {
      width: 100%;
      object-fit: cover;
    }
  }

  .content-container {
    margin: 74px 0px 12px 0px;
    text-align: center;
    font-size: 18px;
    max-width: 68.8%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .dvsum-log {
      margin-bottom: 80px;
      img {
        width: 85px;
      }
    }

    .header {
      margin-bottom: 71px;
      font-size: 29px;
      font-family: OpenSansBold;

      .header-description {
        font-family: OpenSansSemiBold;
        font-size: 21px;
      }
    }

    .icon-container {
      margin-bottom: 63px;
    }

    .description {
      margin-bottom: 26px;
    }

    .login-btn-container {
      display: flex;
      justify-content: center;
      margin-bottom: 26px;

      button {
        background: ${({ theme }): string => theme.bgColors.ORANGE_6};
        color: ${({ theme }): string => theme.textColors.WHITE_COLOR};
        border: none;
        border-radius: 27px;
        height: 52px;
        width: 141px;
        font-size: 20px;
        font-family: OpenSansBold;
      }
    }

    .or-text {
      margin-bottom: 32px;
      font-family: OpenSansSemiBold;
    }
  }
`;
